import { Box } from "@mui/material";
import type { ReactNode } from "react";

interface TabProps {
  children?: ReactNode;
  index: number;
  value: number;
}

export function SecondaryTabPanel({
  children,
  value,
  index,
}: Readonly<TabProps>) {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && <Box sx={{ py: 3, height: 40 }}>{children}</Box>}
    </Box>
  );
}
